import { Directive, ElementRef, HostListener, OnInit, AfterViewInit } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

@Directive({
    selector: '[directive="draw-base-height"]',
})
export class DrawBaseHeightDirective implements OnInit, AfterViewInit {
    public elem: HTMLElement;

    constructor(
        private _elementRef: ElementRef<HTMLElement>,
        private _drawCollapseService: DrawCollapseService,
    ) {}

    @HostListener('window:resize') private _onResize(): void {
        this._handleOnResize();
    }

    ngOnInit(): void {
        this.elem = this._elementRef?.nativeElement;
    }

    ngAfterViewInit(): void {
        this._handleOnResize();

        this._drawCollapseService.toggleDraw(true);
    }

    private _handleOnResize(): void {
        if(!this.elem) {
            return;
        }

        this._drawCollapseService.setBaseMinimalHeight(this.elem.clientHeight);
    }
}
